import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { User } from "firebase/auth";
import { useAdminAuth } from "./useAdminAuth";

export function useAdminToggleMutation<TArg>(
  storeId: string,
  mutationFn: (user: User, storeId: string, arg: TArg) => Promise<void>,
  successMessage: string,
  onSuccess?: () => void
) {
  const user = useAdminAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (arg: TArg) => mutationFn(user!, storeId, arg),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["store", storeId] });
      toast.success(successMessage);
      onSuccess?.();
    },
    onError: (err) => toast.error((err as Error).message),
  });
}
